import type { VendorMetadataExtractor } from './types'
import { extractEmbeddedGps } from './embedded-gps'

export const viofoExtractor: VendorMetadataExtractor = {
  vendorId: 'viofo',
  vendorLabel: 'VIOFO',
  supportsDirectoryBrowse: false,

  // VIOFO (Novatek) writes NMEA-like text in `free` boxes; read by the shared embedded GPS scanner.
  // Binary Novatek GPS blocks are not parsed (out of scope).
  extractFromFiles: extractEmbeddedGps
}
